import styled from 'styled-components';

import { font } from 'app/shared/styles/_fontsize';
import { stacked } from 'app/shared/styles/_spacing';
import { colors } from 'app/shared/styles/_colors';

// Components
import Linker from 'app/shared/modules/Linker';

export const FlexSection = styled.section`
  ${stacked._2x};
  display: flex;
  justify-content: center;
`;

export const NextPage = styled(Linker)`
  ${font.md};
  display: inline-flex;
  align-items: center;
  height: 40px;
  padding: 0 24px;
  color: ${colors['$hpx-white']};
  font-weight: bold;
  background-color: ${colors['$hpx-teal-500']};
  border: 1px solid ${colors['$hpx-teal-500']};
  border-radius: 4px;
`;

export const ArrowIcon = styled.img`
  margin-left: 4px;
  transform: rotate(270deg);
`;
